// extracted by mini-css-extract-plugin
export default {"container":"Aaliv_4CfPgVSF9fPVcm","wide":"GHGYxWbG6sH7cYxul_ZA","content":"RfkAaLnEp0zXG8o7dto8","table_header":"MLlHN5l3_XEdC0200PZc","bottom":"jTp5HzaPRIE8Nd04NcZt"};